<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Body-Text-No-Indent-SpB4--Body-">Who knoweth the spirit of man that goeth upward, and the spirit of the beast that goeth downward to the earth?</p>
<p class="right">ECCLESIASTES 3:21</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?d263945c